<div class="references">
    <div class="dropdown">
        <h4>References</h4>
        <div class="dropdown__button" (click)="toggleDropdown()">
            <img src="assets/icons/icon-arrow-down.svg" [ngClass]="{'rotate180' : showDropdown}" alt="Dropdown arrow">
        </div>
    </div>
    <!-- Dropdown needs to animate -->
    <div class="c-dropdown" [ngClass]="{'c-dropdown--active': showDropdown}" #dropdownContainer>
        <ol #dropdown>
            <li *ngFor="let reference of references"><span>{{ allReferences[reference] }}</span></li>
        </ol>
    </div>
</div>